// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InstantBook-errorMessage-dyFJY {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}
.InstantBook-space1-nrqsV {
	margin-bottom: 6px !important;
}
.InstantBook-space2-T8bwd {
	margin-bottom: 12px !important;
}
.InstantBook-space3-Fy9Cm {
	margin-bottom: 18px !important;
}
.InstantBook-space4-sLPl6 {
	margin-bottom: 24px !important;
}
.InstantBook-space5-bDMRY {
	margin-bottom: 30px !important;
}
.InstantBook-space6-MpmZY {
	margin-bottom: 36px !important;
}
.InstantBook-space7-BjK6b {
	margin-bottom: 42px !important;
}
.InstantBook-space8-bCbJK {
	margin-bottom: 48px !important;
}
.InstantBook-spaceTop1-OQTkK {
	margin-top: 6px !important;
}
.InstantBook-spaceTop2-B9k52 {
	margin-top: 12px !important;
}
.InstantBook-spaceTop3-srmrd {
	margin-top: 18px !important;
}
.InstantBook-spaceTop4-Q8vNm {
	margin-top: 24px !important;
}
.InstantBook-spaceTop5-X5fzW {
	margin-top: 30px !important;
}
.InstantBook-spaceTop6-JKI14 {
	margin-top: 36px !important;
}
.InstantBook-spaceTop7-AWcsT {
	margin-top: 42px !important;
}
.InstantBook-spaceTop8-Gz4Dv {
	margin-top: 48px !important;
}
.InstantBook-noMargin-HgrF2 {
	margin: 0px !important;
}
.InstantBook-padding1-lpgOT {
	padding-bottom: 6px !important;
}
.InstantBook-padding2-pJ2mf {
	padding-bottom: 12px !important;
}
.InstantBook-padding3-d5Eu6 {
	padding-bottom: 18px !important;
}
.InstantBook-padding4-I5lCD {
	padding-bottom: 24px !important;
}
.InstantBook-padding5-ZPTaV {
	padding-bottom: 30px !important;
}
.InstantBook-padding6-Otk_4 {
	padding-bottom: 36px !important;
}
.InstantBook-padding7-ZlZp5 {
	padding-bottom: 42px !important;
}
.InstantBook-paddingTop1-TeWZB {
	padding-top: 6px !important;
}
.InstantBook-paddingTop2-uD9bn {
	padding-top: 12px !important;
}
.InstantBook-paddingTop3-eVwPC {
	padding-top: 18px !important;
}
.InstantBook-paddingTop4-Ar8Qh {
	padding-top: 24px !important;
}
.InstantBook-paddingTop5-YIBh8 {
	padding-top: 30px !important;
}
.InstantBook-paddingTop6-j_jrb {
	padding-top: 36px !important;
}
.InstantBook-paddingTop7-k_54L {
	padding-top: 42px !important;
}
.InstantBook-noPadding-rymbH {
	padding: 0px !important;
}
.InstantBook-spaceMarginBottom0-qQGi0 {
	margin-bottom: 0;
}
.InstantBook-textBold-wxa8o {
	font-weight: 500 !important;
}
.InstantBook-textBolder-fLOtj {
	font-weight: 700 !important;
}
.InstantBook-textNormal-WnOSr {
	font-weight: normal !important;
}
/*New Design Text Colors */
.InstantBook-textDarkBlue-Z5N7J {
	color: rgb(20, 39, 94) !important;
}
.InstantBook-textLightBlue-acVip {
	color: rgb(57, 87, 106) !important;
}
.InstantBook-textLightSandleGreen-pM2qy {
	color: rgb(76, 86, 41) !important;
}
.InstantBook-textLightBrown-SyVX0 {
	color: rgb(115, 79, 33) !important;
}
.InstantBook-textMediumMaroon-qV_mN {
	color: rgb(87, 37, 51) !important;
}
.InstantBook-textBrown-lYPI5 {
	color: rgb(160, 47, 24) !important;
}
.InstantBook-textMaroon-u0Yxf {
	color: rgb(155, 49, 67) !important;
}
.InstantBook-textDarkBrown-PI2BN {
	color: rgb(83, 18, 16) !important;
}
.InstantBook-textMediumBrown-XeR_p {
	color: rgb(142, 28, 10) !important;
}
.InstantBook-textSkyBlue-jDkLH {
	color: rgb(37, 117, 141) !important;
}
.InstantBook-textGray-5ZXYf {
	color: rgb(77, 65, 51) !important;
}
.InstantBook-btn-lP0vl,
.InstantBook-btn-lP0vl:focus {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 8px 12px 8px !important;
	width: auto;
	outline: 0 !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 6px !important;
	background: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
}
.InstantBook-btn-lP0vl:hover {
	background: var(--common-background-color) !important;
	outline: 0 !important;
	color: var(--white-text) !important;
	font-weight: 500;
}
.InstantBook-btn-lP0vl:hover img {
	-webkit-filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(104%) contrast(102%);
	        filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(104%) contrast(102%);
}
.InstantBook-btnPrimary-exVk1,
.InstantBook-btnPrimary-exVk1:focus {
	border-color: var(--btn-primary-bg) !important;
	background-color: var(--btn-primary-bg) !important;
	color: var(--white-text) !important;
	font-weight: 500;
}
.InstantBook-btnPrimary-exVk1:hover {
	border-color: var(--btn-primary-bg-hover) !important;
	background-color: var(--btn-primary-bg-hover) !important;
	color: var(--white-text) !important;
	font-weight: 500;
}
.InstantBook-btnPrimaryBorder-MrBG2,
.InstantBook-btnPrimaryBorder-MrBG2:focus {
	border-color: var(--primary-border) !important;
	color: var(--common-text-color) !important;
	background-color: var(--btn-primary-color) !important;
	border-radius: 6px;
	padding: 8px 12px 8px !important;
	font-weight: 500;
	-webkit-box-shadow: inherit !important;
	        box-shadow: inherit !important;
}
.InstantBook-btnPrimaryBorder-MrBG2:hover {
	border-color: var(--primary-border) !important;
	color: var(--common-text-color) !important;
	background-color: var(--btn-primary-color) !important;
	text-decoration: none !important;
	font-weight: 500;
}
.InstantBook-btnSecondary-lcQ6s,
.InstantBook-btnSecondary-lcQ6s:focus {
	border: 1px solid var(--primary-border) !important;
	background-color: var(--btn-secondary-bg) !important;
	color: var(--white-text) !important;
	padding: 8px 12px 8px !important;
	font-weight: 500;
	white-space: pre-line;
}
.InstantBook-btnSecondary-lcQ6s:hover {
	border: 1px solid var(--primary-border) !important;
	background-color: var(--btn-secondary-hover-bg) !important;
	color: var(--white-text) !important;
	font-weight: 500;
}
.InstantBook-btnLink-YOlHK,
.InstantBook-btnLink-YOlHK:focus {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	width: auto !important;
	outline: 0 !important;
	background: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: inherit;
	border: 0px !important;
}
.InstantBook-btnLink-YOlHK:hover {
	background: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	outline: 0 !important;
	text-decoration: underline;
	font-weight: 500;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	border: 0px !important;
}
.InstantBook-btnLinkPrimary-ATR98,
.InstantBook-btnLinkPrimary-ATR98:focus {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
}
.InstantBook-btnLinkPrimary-ATR98:hover {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
}
.InstantBook-btnLinkSecondary-IeSVl,
.InstantBook-btnLinkSecondary-IeSVl:focus {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-link-color) !important;
	font-size: 16px;
	font-weight: 500;
	border-bottom: 1px solid var(--common-link-color) !important;
	border-radius: 0 !important;
	padding: 0 !important;
}
.InstantBook-btnLinkSecondary-IeSVl:hover {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-link-color) !important;
	font-weight: 500;
	text-decoration: none !important;
	border-bottom: 1px solid var(--common-link-color) !important;
}
.InstantBook-searchFilterPopover-wB_Ec {
	position: absolute;
	top: 57px;
	left: 0px;
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	display: inline-block;
	visibility: visible;
	background: var(--primary-white-bg);
	-o-border-image: initial;
	   border-image: initial;
	-webkit-box-shadow: 0px 3px 6px #00000029;
	        box-shadow: 0px 3px 6px #00000029;
	border-radius: 12px;
}
.InstantBook-searchFilterPopoverFull-WIv8R {
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	position: fixed;
	left: 0px;
	bottom: 0px;
	width: 66%;
	height: initial;
	-webkit-box-shadow: none;
	        box-shadow: none;
	visibility: visible;
	top: 148px;
	background: var(--primary-white-bg);
	border-radius: 4px;
	border-width: initial;
	border-style: none;
	border-color: initial;
	-o-border-image: initial;
	   border-image: initial;
}
.InstantBook-searchFilterPopoverOverlay-Vfrd5 {
	position: fixed;
	height: 100vh;
	width: 100%;
	top: 64px;
	z-index: 2;
	background: rgba(255, 255, 255, 0.85);
	left: 0;
	right: 0;
	bottom: 0;
}
.InstantBook-searchFilterPopoverContent-jfpek {
	min-width: 370px;
	padding: 26px 26px 16px;
	height: 294px;
}
.InstantBook-searchFilterCloseIcon-ueH3j {
	font-size: 30px;
	color: var(--modalText-color);
}
.InstantBook-searchFilterPopoverFooter-tNlSZ {
	width: 100%;
	position: relative;
	line-height: 0;
}
.InstantBook-displayTable-jt0Qe {
	display: table;
	width: 100%;
	vertical-align: middle;
}
.InstantBook-displayTableRow-MdCqI {
	display: table-row;
	vertical-align: middle;
}
.InstantBook-displayTableCell-FLmam {
	display: table-cell;
	vertical-align: middle;
}
.InstantBook-displayInlineBlock-EzxUU {
	display: inline-block;
	vertical-align: top;
	white-space: normal;
}
.InstantBook-fullWidth-UfFFA {
	width: 100% !important;
}
.InstantBook-captionTitle-ZnMsA {
	font-size: 18px;
}
.InstantBook-showTabletSection-h0584 {
	display: none !important;
}
.InstantBook-incrementDecrementButton-CDaMl {
	width: 100%;
	border: 1px solid var(--primary-border);
	border-radius: 6px;
	display: block;
	overflow: hidden;
	-webkit-appearance: none;
}
.InstantBook-commonBorder-GY2Fq {
	border: 1px solid transparent !important;
	color: var(--modalText-color) !important;
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
	border-radius: 60px !important;
	box-shadow: 0 1px 15px 3px #eeebeb !important;
	-webkit-box-shadow: 0 1px 15px 3px #eeebeb !important;
	-webkit-appearance: none !important;
}
.InstantBook-textCenter-TbGmp {
	text-align: center;
}
@media screen and (max-width: 768px) {
	.InstantBook-searchFilterPopoverFull-WIv8R {
		width: 100%;
		height: 100%;
		top: 0px;
		-webkit-box-shadow: none;
		        box-shadow: none;
		border: 1px solid var(--primary-white-bg);
		max-height: 100%;
		-webkit-overflow-scrolling: touch;
	}

	.InstantBook-searchFilterPopoverContent-jfpek {
		min-width: 320px;
		padding: 15px 15px 70px !important;
		height: 100%;
		min-height: 50vh;
		overflow: hidden;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	.InstantBook-searchFilterPopoverHeader-vGURG {
		position: fixed;
		top: 0;
		z-index: 7;
		left: 0;
		right: 0;
		width: 100%;
		padding: 10px 15px;
		background: var(--primary-white-bg);
	}

	.InstantBook-searchFilterPopoverFooter-tNlSZ {
		font-weight: 600;
		position: fixed;
		top: 38%;
		left: 0;
		right: 0;
		background-color: transparent;
		z-index: 10;
	}

	.InstantBook-textSize-P_9HM {
		font-size: 20px;
		font-weight: 600;
		display: block;
		width: 100% !important;
		height: 45px;
	}
}
.InstantBook-capitalizeText-gRSFW {
	text-transform: capitalize;
}
.InstantBook-hideBothTabletAndMobile-b15w6 {
	display: inline-block;
}
@media (max-width: 1199px) {
	.InstantBook-hideBothTabletAndMobile-b15w6 {
		display: none !important;
	}
}
@media screen and (max-width: 350px) {
	.InstantBook-btnFontsize-s74vV {
		font-size: 12px !important;
	}
}
@media (max-width: 360px) {
	.InstantBook-searchFilterCloseIcon-ueH3j {
		font-size: 25px;
	}
}
.InstantBook-transmissionBottom-sYkNy {
	padding-bottom: 21px !important;
}
.InstantBook-marginTop20-NhCmd {
	margin-top: 35px;
}
.InstantBook-marginRight15-Z4aWb {
	margin-right: 15px !important;
}
.InstantBook-marginNone-dvJSg {
	margin: 0 !important;
}
.InstantBook-paddingNone-PwqLH {
	padding: 0 !important;
}
.InstantBook-infoPadding-zV14k {
	padding-right: 6px;
}
@media(min-width:768px) {
	.InstantBook-pullRight-AW9Gf {
		float: right;
	}
}
.InstantBook-displayFlex-Tcf62 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}
@media(max-width:767px) {

	.InstantBook-displayFlex-Tcf62 {
		-webkit-box-pack: justify;
		    -ms-flex-pack: justify;
		        justify-content: space-between;
	}

	.InstantBook-hideTabletSection-RsdiN {
		display: none !important;
	}

	.InstantBook-showTabletSection-h0584 {
		display: block !important;
	}
}
/*****************Apply Button Alignment Start **********************/
.InstantBook-applyBtnDesktop-QrEYa {
	text-align: right;
}
.InstantBook-applyBtn-HCxIC,
.InstantBook-applyBtn-HCxIC:hover,
.InstantBook-applyBtn-HCxIC:active,
.InstantBook-applyBtn-HCxIC:focus {
	background-color: var(--common-background-color) !important;
	color: var(--white-text) !important;
	border-radius: 6px;
	text-decoration: none;
	padding: 9px 15px 10px;
	font-size: 16px;
}
@media screen and (max-width: 991px) {
	.InstantBook-applyBtnDesktop-QrEYa {
		text-align: center;
	}

	.InstantBook-applyBtnDesktopRight-zXdWq {
		text-align: right !important;
	}

	.InstantBook-applyBtnDesktopNoPaddingRight-qpAJ9 {
		padding-right: 0px !important;
	}
}
@media screen and (max-width: 767px) {
	.InstantBook-searchFilterPopoverFooter-tNlSZ {
		position: relative !important;
		top: inherit;
	}
}
/*****************Apply Button Alignment Start **********************/
/*************************** Header Modal Start **********************/
.InstantBook-activeItem-KeFMs {
	padding: 15px;
	text-align: center;
	font-size: 16px;
	border-radius: 6px;
	cursor: pointer;
	border: 1px solid var(--primary-border);
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}
.InstantBook-activeItem-KeFMs:hover,
.InstantBook-activeItem-KeFMs:focus,
.InstantBook-activeItem-KeFMs:active {
	background-color: var(--common-background-color);
	color: var(--white-text);
	border-radius: 6px;
}
.InstantBook-activeSection-pRYxc:first-child {
	background-color: var(--common-background-color);
	color: var(--white-text);
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}
.InstantBook-currencyAndLangGrid-aZzP_ {
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 12px;
}
@media (max-width:767px) {
	.InstantBook-currencyAndLangGrid-aZzP_ {
		grid-template-columns: repeat(2, 1fr);
	}
}
/*************************** Header Modal End **********************/`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/common.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;ACRA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzLA;;CAEC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,gCAAgC;CAChC,WAAW;CACX,qBAAqB;CACrB,kDAAkD;CAClD,6BAA6B;CAC7B,8CAA8C;CAC9C,0CAA0C;CAC1C,gBAAgB;AACjB;AAEA;CACC,qDAAqD;CACrD,qBAAqB;CACrB,mCAAmC;CACnC,gBAAgB;AACjB;AAEA;CACC,qGAA6F;SAA7F,6FAA6F;AAC9F;AAEA;;CAEC,8CAA8C;CAC9C,kDAAkD;CAClD,mCAAmC;CACnC,gBAAgB;AACjB;AAEA;CACC,oDAAoD;CACpD,wDAAwD;CACxD,mCAAmC;CACnC,gBAAgB;AACjB;AAEA;;CAEC,8CAA8C;CAC9C,0CAA0C;CAC1C,qDAAqD;CACrD,kBAAkB;CAClB,gCAAgC;CAChC,gBAAgB;CAChB,sCAA8B;SAA9B,8BAA8B;AAC/B;AAEA;CACC,8CAA8C;CAC9C,0CAA0C;CAC1C,qDAAqD;CACrD,gCAAgC;CAChC,gBAAgB;AACjB;AAEA;;CAEC,kDAAkD;CAClD,oDAAoD;CACpD,mCAAmC;CACnC,gCAAgC;CAChC,gBAAgB;CAChB,qBAAqB;AACtB;AAEA;CACC,kDAAkD;CAClD,0DAA0D;CAC1D,mCAAmC;CACnC,gBAAgB;AACjB;AAEA;;CAEC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,sBAAsB;CACtB,qBAAqB;CACrB,8CAA8C;CAC9C,0CAA0C;CAC1C,gBAAgB;CAChB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,8CAA8C;CAC9C,0CAA0C;CAC1C,qBAAqB;CACrB,0BAA0B;CAC1B,gBAAgB;CAChB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,sBAAsB;AACvB;AAEA;;CAEC,oDAAoD;CACpD,0CAA0C;CAC1C,gBAAgB;AACjB;AAEA;CACC,oDAAoD;CACpD,0CAA0C;CAC1C,gBAAgB;AACjB;AAEA;;CAEC,oDAAoD;CACpD,0CAA0C;CAC1C,eAAe;CACf,gBAAgB;CAChB,4DAA4D;CAC5D,2BAA2B;CAC3B,qBAAqB;AACtB;AAEA;CACC,oDAAoD;CACpD,0CAA0C;CAC1C,gBAAgB;CAChB,gCAAgC;CAChC,4DAA4D;AAC7D;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,mBAAmB;CACnB,mCAAmC;CACnC,wBAAqB;IAArB,qBAAqB;CACrB,yCAAiC;SAAjC,iCAAiC;CACjC,mBAAmB;AACpB;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,SAAS;CACT,WAAW;CACX,UAAU;CACV,eAAe;CACf,wBAAgB;SAAhB,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;CACV,mCAAmC;CACnC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,qBAAqB;CACrB,wBAAqB;IAArB,qBAAqB;AACtB;AAEA;CACC,eAAe;CACf,aAAa;CACb,WAAW;CACX,SAAS;CACT,UAAU;CACV,qCAAqC;CACrC,OAAO;CACP,QAAQ;CACR,SAAS;AACV;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,aAAa;AACd;AAEA;CACC,eAAe;CACf,6BAA6B;AAC9B;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,cAAc;AACf;AAEA;CACC,cAAc;CACd,WAAW;CACX,sBAAsB;AACvB;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,mBAAmB;AACpB;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,wBAAwB;AACzB;AAEA;CACC,WAAW;CACX,uCAAuC;CACvC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,wBAAwB;AACzB;AAEA;CACC,wCAAwC;CACxC,wCAAwC;CACxC,mCAA2B;SAA3B,2BAA2B;CAC3B,8BAA8B;CAC9B,6CAA6C;CAC7C,qDAAqD;CACrD,mCAAmC;AACpC;AAGA;CACC,kBAAkB;AACnB;AAEA;CACC;EACC,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,wBAAgB;UAAhB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,iCAAiC;CAClC;;CAEA;EACC,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;CAClC;;CAEA;EACC,eAAe;EACf,MAAM;EACN,UAAU;EACV,OAAO;EACP,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,mCAAmC;CACpC;;CAEA;EACC,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,6BAA6B;EAC7B,WAAW;CACZ;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,YAAY;CACb;AACD;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,qBAAqB;AACtB;AAEA;CACC;EACC,wBAAwB;CACzB;AACD;AAEA;CACC;EACC,0BAA0B;CAC3B;AACD;AAEA;CACC;EACC,eAAe;CAChB;AACD;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,6BAA6B;AAC9B;AAEA;CACC,oBAAoB;AACrB;AAEA;CACC,qBAAqB;AACtB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC;EACC,YAAY;CACb;AACD;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,mBAAe;KAAf,eAAe;AAChB;AAEA;;CAEC;EACC,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;CAC/B;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,yBAAyB;CAC1B;AACD;AAEA,qEAAqE;AAErE;CACC,iBAAiB;AAClB;AAEA;;;;CAIC,2DAA2D;CAC3D,mCAAmC;CACnC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,eAAe;AAChB;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC,6BAA6B;CAC9B;AACD;AAEA;CACC;EACC,6BAA6B;EAC7B,YAAY;CACb;AACD;AAEA,qEAAqE;AACrE,sEAAsE;AACtE;CACC,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,uCAAuC;CACvC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;AAEA;;;CAGC,gDAAgD;CAChD,wBAAwB;CACxB,kBAAkB;AACnB;AAEA;CACC,gDAAgD;CAChD,wBAAwB;CACxB,uCAAuC;CACvC,kBAAkB;AACnB;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;AACV;AAEA;CACC;EACC,qCAAqC;CACtC;AACD;AAEA,oEAAoE","sourcesContent":[".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import 'utils.css';\n@import 'helpers.css';\n\n.btn,\n.btn:focus {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 8px 12px 8px !important;\n\twidth: auto;\n\toutline: 0 !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 6px !important;\n\tbackground: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n}\n\n.btn:hover {\n\tbackground: var(--common-background-color) !important;\n\toutline: 0 !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btn:hover img {\n\tfilter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(104%) contrast(102%);\n}\n\n.btnPrimary,\n.btnPrimary:focus {\n\tborder-color: var(--btn-primary-bg) !important;\n\tbackground-color: var(--btn-primary-bg) !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btnPrimary:hover {\n\tborder-color: var(--btn-primary-bg-hover) !important;\n\tbackground-color: var(--btn-primary-bg-hover) !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btnPrimaryBorder,\n.btnPrimaryBorder:focus {\n\tborder-color: var(--primary-border) !important;\n\tcolor: var(--common-text-color) !important;\n\tbackground-color: var(--btn-primary-color) !important;\n\tborder-radius: 6px;\n\tpadding: 8px 12px 8px !important;\n\tfont-weight: 500;\n\tbox-shadow: inherit !important;\n}\n\n.btnPrimaryBorder:hover {\n\tborder-color: var(--primary-border) !important;\n\tcolor: var(--common-text-color) !important;\n\tbackground-color: var(--btn-primary-color) !important;\n\ttext-decoration: none !important;\n\tfont-weight: 500;\n}\n\n.btnSecondary,\n.btnSecondary:focus {\n\tborder: 1px solid var(--primary-border) !important;\n\tbackground-color: var(--btn-secondary-bg) !important;\n\tcolor: var(--white-text) !important;\n\tpadding: 8px 12px 8px !important;\n\tfont-weight: 500;\n\twhite-space: pre-line;\n}\n\n.btnSecondary:hover {\n\tborder: 1px solid var(--primary-border) !important;\n\tbackground-color: var(--btn-secondary-hover-bg) !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btnLink,\n.btnLink:focus {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: inherit;\n\tborder: 0px !important;\n}\n\n.btnLink:hover {\n\tbackground: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\toutline: 0 !important;\n\ttext-decoration: underline;\n\tfont-weight: 500;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tborder: 0px !important;\n}\n\n.btnLinkPrimary,\n.btnLinkPrimary:focus {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n}\n\n.btnLinkPrimary:hover {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n}\n\n.btnLinkSecondary,\n.btnLinkSecondary:focus {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-link-color) !important;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tborder-bottom: 1px solid var(--common-link-color) !important;\n\tborder-radius: 0 !important;\n\tpadding: 0 !important;\n}\n\n.btnLinkSecondary:hover {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-link-color) !important;\n\tfont-weight: 500;\n\ttext-decoration: none !important;\n\tborder-bottom: 1px solid var(--common-link-color) !important;\n}\n\n.searchFilterPopover {\n\tposition: absolute;\n\ttop: 57px;\n\tleft: 0px;\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tdisplay: inline-block;\n\tvisibility: visible;\n\tbackground: var(--primary-white-bg);\n\tborder-image: initial;\n\tbox-shadow: 0px 3px 6px #00000029;\n\tborder-radius: 12px;\n}\n\n.searchFilterPopoverFull {\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tposition: fixed;\n\tleft: 0px;\n\tbottom: 0px;\n\twidth: 66%;\n\theight: initial;\n\tbox-shadow: none;\n\tvisibility: visible;\n\ttop: 148px;\n\tbackground: var(--primary-white-bg);\n\tborder-radius: 4px;\n\tborder-width: initial;\n\tborder-style: none;\n\tborder-color: initial;\n\tborder-image: initial;\n}\n\n.searchFilterPopoverOverlay {\n\tposition: fixed;\n\theight: 100vh;\n\twidth: 100%;\n\ttop: 64px;\n\tz-index: 2;\n\tbackground: rgba(255, 255, 255, 0.85);\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n}\n\n.searchFilterPopoverContent {\n\tmin-width: 370px;\n\tpadding: 26px 26px 16px;\n\theight: 294px;\n}\n\n.searchFilterCloseIcon {\n\tfont-size: 30px;\n\tcolor: var(--modalText-color);\n}\n\n.searchFilterPopoverFooter {\n\twidth: 100%;\n\tposition: relative;\n\tline-height: 0;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n\tvertical-align: middle;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\tvertical-align: middle;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.displayInlineBlock {\n\tdisplay: inline-block;\n\tvertical-align: top;\n\twhite-space: normal;\n}\n\n.fullWidth {\n\twidth: 100% !important;\n}\n\n.captionTitle {\n\tfont-size: 18px;\n}\n\n.showTabletSection {\n\tdisplay: none !important;\n}\n\n.incrementDecrementButton {\n\twidth: 100%;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n\tdisplay: block;\n\toverflow: hidden;\n\t-webkit-appearance: none;\n}\n\n.commonBorder {\n\tborder: 1px solid transparent !important;\n\tcolor: var(--modalText-color) !important;\n\tbox-shadow: none !important;\n\tborder-radius: 60px !important;\n\tbox-shadow: 0 1px 15px 3px #eeebeb !important;\n\t-webkit-box-shadow: 0 1px 15px 3px #eeebeb !important;\n\t-webkit-appearance: none !important;\n}\n\n\n.textCenter {\n\ttext-align: center;\n}\n\n@media screen and (max-width: 768px) {\n\t.searchFilterPopoverFull {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\ttop: 0px;\n\t\tbox-shadow: none;\n\t\tborder: 1px solid var(--primary-white-bg);\n\t\tmax-height: 100%;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.searchFilterPopoverContent {\n\t\tmin-width: 320px;\n\t\tpadding: 15px 15px 70px !important;\n\t\theight: 100%;\n\t\tmin-height: 50vh;\n\t\toverflow: hidden;\n\t\toverflow-y: auto;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.searchFilterPopoverHeader {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tz-index: 7;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: 100%;\n\t\tpadding: 10px 15px;\n\t\tbackground: var(--primary-white-bg);\n\t}\n\n\t.searchFilterPopoverFooter {\n\t\tfont-weight: 600;\n\t\tposition: fixed;\n\t\ttop: 38%;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbackground-color: transparent;\n\t\tz-index: 10;\n\t}\n\n\t.textSize {\n\t\tfont-size: 20px;\n\t\tfont-weight: 600;\n\t\tdisplay: block;\n\t\twidth: 100% !important;\n\t\theight: 45px;\n\t}\n}\n\n.capitalizeText {\n\ttext-transform: capitalize;\n}\n\n.hideBothTabletAndMobile {\n\tdisplay: inline-block;\n}\n\n@media (max-width: 1199px) {\n\t.hideBothTabletAndMobile {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media screen and (max-width: 350px) {\n\t.btnFontsize {\n\t\tfont-size: 12px !important;\n\t}\n}\n\n@media (max-width: 360px) {\n\t.searchFilterCloseIcon {\n\t\tfont-size: 25px;\n\t}\n}\n\n.transmissionBottom {\n\tpadding-bottom: 21px !important;\n}\n\n.marginTop20 {\n\tmargin-top: 35px;\n}\n\n.marginRight15 {\n\tmargin-right: 15px !important;\n}\n\n.marginNone {\n\tmargin: 0 !important;\n}\n\n.paddingNone {\n\tpadding: 0 !important;\n}\n\n.infoPadding {\n\tpadding-right: 6px;\n}\n\n@media(min-width:768px) {\n\t.pullRight {\n\t\tfloat: right;\n\t}\n}\n\n.displayFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tflex-wrap: wrap;\n}\n\n@media(max-width:767px) {\n\n\t.displayFlex {\n\t\tjustify-content: space-between;\n\t}\n\n\t.hideTabletSection {\n\t\tdisplay: none !important;\n\t}\n\n\t.showTabletSection {\n\t\tdisplay: block !important;\n\t}\n}\n\n/*****************Apply Button Alignment Start **********************/\n\n.applyBtnDesktop {\n\ttext-align: right;\n}\n\n.applyBtn,\n.applyBtn:hover,\n.applyBtn:active,\n.applyBtn:focus {\n\tbackground-color: var(--common-background-color) !important;\n\tcolor: var(--white-text) !important;\n\tborder-radius: 6px;\n\ttext-decoration: none;\n\tpadding: 9px 15px 10px;\n\tfont-size: 16px;\n}\n\n@media screen and (max-width: 991px) {\n\t.applyBtnDesktop {\n\t\ttext-align: center;\n\t}\n\n\t.applyBtnDesktopRight {\n\t\ttext-align: right !important;\n\t}\n\n\t.applyBtnDesktopNoPaddingRight {\n\t\tpadding-right: 0px !important;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.searchFilterPopoverFooter {\n\t\tposition: relative !important;\n\t\ttop: inherit;\n\t}\n}\n\n/*****************Apply Button Alignment Start **********************/\n/*************************** Header Modal Start **********************/\n.activeItem {\n\tpadding: 15px;\n\ttext-align: center;\n\tfont-size: 16px;\n\tborder-radius: 6px;\n\tcursor: pointer;\n\tborder: 1px solid var(--primary-border);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.activeItem:hover,\n.activeItem:focus,\n.activeItem:active {\n\tbackground-color: var(--common-background-color);\n\tcolor: var(--white-text);\n\tborder-radius: 6px;\n}\n\n.activeSection:first-child {\n\tbackground-color: var(--common-background-color);\n\tcolor: var(--white-text);\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.currencyAndLangGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(5, 1fr);\n\tgap: 12px;\n}\n\n@media (max-width:767px) {\n\t.currencyAndLangGrid {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n\n/*************************** Header Modal End **********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `InstantBook-errorMessage-dyFJY`,
	"space1": `InstantBook-space1-nrqsV`,
	"space2": `InstantBook-space2-T8bwd`,
	"space3": `InstantBook-space3-Fy9Cm`,
	"space4": `InstantBook-space4-sLPl6`,
	"space5": `InstantBook-space5-bDMRY`,
	"space6": `InstantBook-space6-MpmZY`,
	"space7": `InstantBook-space7-BjK6b`,
	"space8": `InstantBook-space8-bCbJK`,
	"spaceTop1": `InstantBook-spaceTop1-OQTkK`,
	"spaceTop2": `InstantBook-spaceTop2-B9k52`,
	"spaceTop3": `InstantBook-spaceTop3-srmrd`,
	"spaceTop4": `InstantBook-spaceTop4-Q8vNm`,
	"spaceTop5": `InstantBook-spaceTop5-X5fzW`,
	"spaceTop6": `InstantBook-spaceTop6-JKI14`,
	"spaceTop7": `InstantBook-spaceTop7-AWcsT`,
	"spaceTop8": `InstantBook-spaceTop8-Gz4Dv`,
	"noMargin": `InstantBook-noMargin-HgrF2`,
	"padding1": `InstantBook-padding1-lpgOT`,
	"padding2": `InstantBook-padding2-pJ2mf`,
	"padding3": `InstantBook-padding3-d5Eu6`,
	"padding4": `InstantBook-padding4-I5lCD`,
	"padding5": `InstantBook-padding5-ZPTaV`,
	"padding6": `InstantBook-padding6-Otk_4`,
	"padding7": `InstantBook-padding7-ZlZp5`,
	"paddingTop1": `InstantBook-paddingTop1-TeWZB`,
	"paddingTop2": `InstantBook-paddingTop2-uD9bn`,
	"paddingTop3": `InstantBook-paddingTop3-eVwPC`,
	"paddingTop4": `InstantBook-paddingTop4-Ar8Qh`,
	"paddingTop5": `InstantBook-paddingTop5-YIBh8`,
	"paddingTop6": `InstantBook-paddingTop6-j_jrb`,
	"paddingTop7": `InstantBook-paddingTop7-k_54L`,
	"noPadding": `InstantBook-noPadding-rymbH`,
	"spaceMarginBottom0": `InstantBook-spaceMarginBottom0-qQGi0`,
	"textBold": `InstantBook-textBold-wxa8o`,
	"textBolder": `InstantBook-textBolder-fLOtj`,
	"textNormal": `InstantBook-textNormal-WnOSr`,
	"textDarkBlue": `InstantBook-textDarkBlue-Z5N7J`,
	"textLightBlue": `InstantBook-textLightBlue-acVip`,
	"textLightSandleGreen": `InstantBook-textLightSandleGreen-pM2qy`,
	"textLightBrown": `InstantBook-textLightBrown-SyVX0`,
	"textMediumMaroon": `InstantBook-textMediumMaroon-qV_mN`,
	"textBrown": `InstantBook-textBrown-lYPI5`,
	"textMaroon": `InstantBook-textMaroon-u0Yxf`,
	"textDarkBrown": `InstantBook-textDarkBrown-PI2BN`,
	"textMediumBrown": `InstantBook-textMediumBrown-XeR_p`,
	"textSkyBlue": `InstantBook-textSkyBlue-jDkLH`,
	"textGray": `InstantBook-textGray-5ZXYf`,
	"btn": `InstantBook-btn-lP0vl`,
	"btnPrimary": `InstantBook-btnPrimary-exVk1`,
	"btnPrimaryBorder": `InstantBook-btnPrimaryBorder-MrBG2`,
	"btnSecondary": `InstantBook-btnSecondary-lcQ6s`,
	"btnLink": `InstantBook-btnLink-YOlHK`,
	"btnLinkPrimary": `InstantBook-btnLinkPrimary-ATR98`,
	"btnLinkSecondary": `InstantBook-btnLinkSecondary-IeSVl`,
	"searchFilterPopover": `InstantBook-searchFilterPopover-wB_Ec`,
	"searchFilterPopoverFull": `InstantBook-searchFilterPopoverFull-WIv8R`,
	"searchFilterPopoverOverlay": `InstantBook-searchFilterPopoverOverlay-Vfrd5`,
	"searchFilterPopoverContent": `InstantBook-searchFilterPopoverContent-jfpek`,
	"searchFilterCloseIcon": `InstantBook-searchFilterCloseIcon-ueH3j`,
	"searchFilterPopoverFooter": `InstantBook-searchFilterPopoverFooter-tNlSZ`,
	"displayTable": `InstantBook-displayTable-jt0Qe`,
	"displayTableRow": `InstantBook-displayTableRow-MdCqI`,
	"displayTableCell": `InstantBook-displayTableCell-FLmam`,
	"displayInlineBlock": `InstantBook-displayInlineBlock-EzxUU`,
	"fullWidth": `InstantBook-fullWidth-UfFFA`,
	"captionTitle": `InstantBook-captionTitle-ZnMsA`,
	"showTabletSection": `InstantBook-showTabletSection-h0584`,
	"incrementDecrementButton": `InstantBook-incrementDecrementButton-CDaMl`,
	"commonBorder": `InstantBook-commonBorder-GY2Fq`,
	"textCenter": `InstantBook-textCenter-TbGmp`,
	"searchFilterPopoverHeader": `InstantBook-searchFilterPopoverHeader-vGURG`,
	"textSize": `InstantBook-textSize-P_9HM`,
	"capitalizeText": `InstantBook-capitalizeText-gRSFW`,
	"hideBothTabletAndMobile": `InstantBook-hideBothTabletAndMobile-b15w6`,
	"btnFontsize": `InstantBook-btnFontsize-s74vV`,
	"transmissionBottom": `InstantBook-transmissionBottom-sYkNy`,
	"marginTop20": `InstantBook-marginTop20-NhCmd`,
	"marginRight15": `InstantBook-marginRight15-Z4aWb`,
	"marginNone": `InstantBook-marginNone-dvJSg`,
	"paddingNone": `InstantBook-paddingNone-PwqLH`,
	"infoPadding": `InstantBook-infoPadding-zV14k`,
	"pullRight": `InstantBook-pullRight-AW9Gf`,
	"displayFlex": `InstantBook-displayFlex-Tcf62`,
	"hideTabletSection": `InstantBook-hideTabletSection-RsdiN`,
	"applyBtnDesktop": `InstantBook-applyBtnDesktop-QrEYa`,
	"applyBtn": `InstantBook-applyBtn-HCxIC`,
	"applyBtnDesktopRight": `InstantBook-applyBtnDesktopRight-zXdWq`,
	"applyBtnDesktopNoPaddingRight": `InstantBook-applyBtnDesktopNoPaddingRight-qpAJ9`,
	"activeItem": `InstantBook-activeItem-KeFMs`,
	"activeSection": `InstantBook-activeSection-pRYxc`,
	"currencyAndLangGrid": `InstantBook-currencyAndLangGrid-aZzP_`
};
module.exports = ___CSS_LOADER_EXPORT___;
